import { render, staticRenderFns } from "./TransferTaskModal.vue?vue&type=template&id=695b2c66&scoped=true&"
import script from "./TransferTaskModal.vue?vue&type=script&lang=js&"
export * from "./TransferTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695b2c66",
  null
  
)

export default component.exports